/**
 * Checkbox component
 * @param {{
 * name:string,
 * checked?:boolean,
 * onChange?:import('react').ChangeEventHandler<HTMLInputElement>
 * }} param0
 * @returns
 */

export default function Checkbox({ name, ...props }) {
  return (
    <input
      name={name}
      id={name}
      className="w-4 h-4 mr-2 rounded-sm focus:ring-0 text-segments-accent-color-1"
      type="checkbox"
      {...props}
    />
  );
}
